import { InferOutput, nullable } from 'valibot'
import { PlayerIdSchema } from './PlayerId'

export const PlayerIdOrNullSchema = nullable(PlayerIdSchema)

export type PlayerIdOrNull = InferOutput<typeof PlayerIdOrNullSchema>
